// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".title-large[data-v-0296f8cc],.title-small[data-v-0296f8cc]{max-height:2.3em}.subtitle[data-v-0296f8cc],.title-large[data-v-0296f8cc],.title-small[data-v-0296f8cc]{-webkit-box-orient:vertical;-webkit-line-clamp:2;display:-webkit-box}.subtitle[data-v-0296f8cc]{max-height:2.25em}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
